import localforage from 'localforage'
import { isEmpty } from 'lodash'

export const SET_TOKEN = (state, token) => {
    if (isEmpty(token)) {
        localforage.removeItem('authtoken')
        return
    }
    localforage.setItem('authtoken', token)
}



export const RESET_AUTH_STATE = state => {
    state.authenticated = false,
        state.user = null;
};